module.exports = __webpack_public_path__ + "static/3ce336f5da5f4ffb91cdd1415d92985c78b9ae35818f8c55be78154338e3bd30-26ad7c942f44d40e5323f18215e75c35.png";